/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%;display:block;position:relative}.labels[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%;height:100%;display:block;z-index:2;pointer-events:none}"];
export { styles as styles };
